import Client from './../Clients/axiosClient'
const resource = 'api/senders'

export default {
  get () {
    return Client.get(`${resource}`)
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
}
